<template>
    <div class="cc-button" :class="{
        'disabled': disabled
    }">
        <button @click.stop="clickHandler" :style="{
            'border-radius': borderRadius,
            'background-color': bgColor
        }">
            <slot />
        </button>
    </div>
</template>

<script>
export default {
    props: {
        // 圆角度数
        borderRadius: {
            type: String,
            default: '50px'
        },
        // 背景颜色
        bgColor: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        clickHandler(e) {
            if (this.disabled) return
            this.$emit('click', e)
        }
    }
}
</script>

<style scoped lang="scss">
// 基本样式
.cc-button button {
    border: 1px solid transparent;
    box-sizing: border-box;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    &:active {
        transform: scale(0.98);
        background-color: #2284e6;
    }
}
// 大小尺寸
.cc-button {
    // 默认
    width: 100%;
    button {
        height: 42px;
        font-size: 16px;
        font-weight: bold;
    }
}
// 主题色
.cc-button {
    button {
        background-color: #409eff;
        color: #ffffff;
    }
}
.cc-button {
    &.disabled button {
        background-color: #c0c4cc;
        color: #ffffff;
    }
}
</style>